// The join-code field: uppercased as typed, the button held back until
// four characters are in (the server normalises and checks again).
import { Controller } from "@hotwired/stimulus"

const MIN_LENGTH = 4

export default class extends Controller {
  static targets = ["input", "submit"]

  connect() {
    this.refresh()
  }

  refresh() {
    const input = this.inputTarget
    const upper = input.value.toUpperCase()
    if (input.value !== upper) input.value = upper
    this.submitTarget.disabled = upper.trim().length < MIN_LENGTH
  }
}
